import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import AboutPage from './pages/about/AboutPage';
import PartnerPage from './pages/partner/PartnerPage';
import BrandPage from './pages/brand/BrandPage';
import BoxPage from './pages/share/BoxPage';
import OppPage from './pages/share/OppPage';
import LeafletPromotionPage from './pages/share/LeafletPromotionPage';
import LeafletAppDownloadPage from './pages/share/LeafletAppDownloadPage';
import PrivacyPolicyPage from './pages/hidden/PrivacyPolicyPage';
import TermsOfServicePage from './pages/hidden/TermsOfServicePage';
import ThirdPartyConsentPage from './pages/hidden/ThirdPartyConsentPage';
import LocationServicePage from './pages/hidden/LocationServicePage';
import FAQPage from './pages/hidden/FAQPage';
import NoticePage from './pages/hidden/NoticePage';
import PointGuidePage from './pages/hidden/PointGuidePage';
import CouponGuidePage from './pages/hidden/CouponGuidePage';
import ProductReceiptGuidePage from './pages/hidden/ProductReceiptGuidePage';
import LensReservationGuidePage from './pages/hidden/LensReservationGuidePage';
import AppDownloadRedirectPage from './pages/hidden/AppDownloadRedirectPage';
import BrandLaunchEventPage from './pages/event/BrandLaunchEventPage';
import NewMemberEventPage from './pages/event/NewMemberEventPage';

function AppContent() {
  const location = useLocation();
  const isSharePage = location.pathname.startsWith('/share');
  const isHiddenPage = location.pathname.startsWith('/hidden');
  const isEventPage = location.pathname.startsWith('/event');

  return (
    <div className="flex flex-col min-h-screen w-full" style={{ backgroundColor: '#FEF1F9' }}>
      {!isSharePage && !isHiddenPage && !isEventPage && <Header />}
      <div className="flex-1 w-full" style={{ backgroundColor: '#FEF1F9' }}>
        <Routes>
          <Route path="/" element={<AboutPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/partner" element={<PartnerPage />} />
          <Route path="/brand" element={<BrandPage />} />
          <Route path="/share/box" element={<BoxPage />} />
          <Route path="/share/opp" element={<OppPage />} />
          <Route path="/share/leaflet-promotion_01" element={<LeafletPromotionPage />} />
          <Route path="/share/leaflet-app-download" element={<LeafletAppDownloadPage />} />
          
          {/* Hidden Pages */}
          <Route path="/hidden/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/hidden/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/hidden/third-party-consent" element={<ThirdPartyConsentPage />} />
          <Route path="/hidden/location-service" element={<LocationServicePage />} />
          <Route path="/hidden/faq" element={<FAQPage />} />
          <Route path="/hidden/notice" element={<NoticePage />} />
          <Route path="/hidden/point-guide" element={<PointGuidePage />} />
          <Route path="/hidden/coupon-guide" element={<CouponGuidePage />} />
          <Route path="/hidden/product-receipt-guide" element={<ProductReceiptGuidePage />} />
          <Route path="/hidden/lens-reservation-guide" element={<LensReservationGuidePage />} />
          <Route path="/hidden/app-download" element={<AppDownloadRedirectPage />} />
          
          {/* Event Pages */}
          <Route path="/event/brand-launch" element={<BrandLaunchEventPage />} />
          <Route path="/event/new-member" element={<NewMemberEventPage />} />
        </Routes>
      </div>
      {!isSharePage && !isHiddenPage && !isEventPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App; 